let AllEnvApiUrls = {
    production: {
      baseUrl: process.env.REACT_APP_PROD_API_URL,
    },
    staging: {
      baseUrl: process.env.REACT_APP_DEV_API_URL,
    },
    development: {
      baseUrl: process.env.REACT_APP_DEV_API_URL,
    },
  };
  const ApiUrl = AllEnvApiUrls[process.env.REACT_APP_APP_ENVIRONMENT] 
  const AuthUrl = `${ApiUrl?.baseUrl}/admin-service/v1`;

  export const URLS = {
    //Auth Url
    login: `${AuthUrl}/auth/login`,
    forgetpassword:`${AuthUrl}/auth/forget-password`,
    getDashboardStats:`${AuthUrl}/admin/getDashboardStats`,
   resetpassword: `${AuthUrl}/auth/reset-password`,

  //User-management Url
    getAllUsers:`${AuthUrl}/admin/getAllUsers`,
    getUserInfoById:`${AuthUrl}/admin/getUserInfoById?id`,

 //Company-management Url
   getAllCompany: `${AuthUrl}/admin/getAllCompany`,
   getCompanyInfoById:`${AuthUrl}/admin/getCompanyInfoById?id`
  };
  